import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Sidebar from './Sidebar'


class Navbar extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div>
                <nav className="nav-wrapper">
                    <div id="ksu-header">

                        <div id="ksu-header-masthead" >

                            <h1><a href="http://www.k-state.edu/">Kansas State University</a></h1>
                            <h3 style={{ color: "White" }}>The Bakery</h3>

                        </div>

                    </div>



                    {this.props.isAuthed ?
                        <Sidebar total={this.props.total} amount={this.props.amount} /> : ""}
                </nav><br />
            </div>

        )
    }
}


const mapStateToProps = (state) => {
    return {
        addedItems: state.addedItems,
        total: state.total,
        topping: state.topping
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addShipping: () => { dispatch({ type: 'ADD_SHIPPING' }) },
        substractShipping: () => { dispatch({ type: 'SUB_SHIPPING' }) }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Navbar)

